module.exports = __webpack_public_path__ + "images/161_160.jpg";